import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSafeBackNavigation } from "../../../../shared/Route/useSafeBackNavigation";
import { PetProfileForm } from "./PetProfileForm";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../store/store";
import { GetPetByIdThunk } from "../../redux/thunk";
import type { Pet } from "../../ts";
import { sleep } from "../../../../utils";
import { useApp } from "../../../../shared/AppProvider/AppProvider";

export const EditPetProfile = () => {
  const { navigate } = useSafeBackNavigation("/");
  const { pet_id } = useParams();
  const dispatch = useAppDispatch();
  const [pet, setPet] = useState<Pet | undefined>(undefined);
  const { notify } = useApp();

  useEffect(() => {
    const loadPet = async () => {
      if (!pet_id) return;

      try {
        await sleep(300);
        const { data } = await dispatch(GetPetByIdThunk({pet_id})).unwrap();
        setPet(data);
     } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        notify("error", error?.message || "Something went wrong");
      } else {
        notify("error", "Something went wrong");
      }
    }
    };

    loadPet();
  }, [pet_id, dispatch]);

  return (
    <div className="space-y-6">
      <div className="flex gap-4 items-start">
        <Button
          className="dark:!text-white dark:!bg-transparent  dark:hover:!bg-gray-600"
          type="default"
          icon={<ArrowLeftOutlined style={{ fontSize: 16 }} />}
          onClick={() => navigate("/profile/my-pets")}
        ></Button>

        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Edit {pet?.name}'s Profile
        </h2>
      </div>

      <PetProfileForm mode={"edit"} initialValues={pet as Pet} />
    </div>
  );
};
